/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

const CMSCrl8GalleryView = ({ containerId }) => {
  useEffect(() => {
    if (!containerId) return;
    if (window.crl8 && typeof window.crl8.ready === 'function') {
      window.crl8.ready(() => {
        console.log(`Curalate gallery initialized for container: ${containerId}`);
      });
    } else {
      console.warn('Curalate script not found on window. Did you add it to <head>?');
    }
  }, [containerId]);

  if (!containerId) return null;

  return <div data-crl8-container-id={containerId} />;
};

CMSCrl8GalleryView.propTypes = {
  containerId: PropTypes.string,
};

CMSCrl8GalleryView.defaultProps = {
  containerId: undefined,
};

export default CMSCrl8GalleryView;
